import axios from "axios";

export const shortenApi = token => {
  return axios
    .get(`/api/shorten?token=${encodeURIComponent(token)}`)
    .then((response) => response.data.url);
}
